import { getPublicUsername } from "../../utils/publicIdentity";

export function isProfileCompletionRequired(user) {
  if (!user?.uid || user?.isAnonymous) return false;

  const username = getPublicUsername(user);
  const identityLocked = Boolean(user?.profile?.identityLockedAt);
  return !username || !identityLocked;
}

export function isProfileCompletionReady(user, profile) {
  return Boolean(profile && !isProfileCompletionRequired(user));
}
